import styles from 'src/js/common/components/formatters/DateFormatter.less';
import baseDateFormatterParams from 'src/js/lib/raw_rendering/base_date_formatter_params';

/**
 * Returns raw Html version of DateFormatter component.
 * @param params
 * @param services
 * @returns {String}
 */
export default function dateFormatter(params, services = {}) {
  const {value, formattedValue} = baseDateFormatterParams(params, services);
  return value
    ? `<div class="${styles.dlDateFormatter}" title="${formattedValue}">
            ${formattedValue}
        </div>`
    : '';
}
